<template>
  <SDialog
    :show-dialog="showDialog"
    :width="450"
    :title="$t('ida.label.exit')"
    @update:show-dialog="emits('update:showDialog', $event)"
    @close="emits('cancel')"
  >
    <VCardText class="px-6 pb-6">
      <p class="text-center mb-4">
        {{ $t('ida.p.exit') }}
      </p>

      <VRow no-gutters>
        <VCol cols="12">
          <SBtn
            color="primary"
            action
            block
            data-testid="join-exit-confirm"
            @click="emits('exit')"
          >
            {{ $t('ida.btn.exit') }}
          </SBtn>
        </VCol>
      </VRow>
      <VRow no-gutters class="mt-3">
        <VCol class="text-center">
          <SBtn
            link-medium
            data-testid="join-exit-cancel"
            @click="emits('cancel')"
          >
            {{ $t('input.btn.cancel') }}
          </SBtn>
        </VCol>
      </VRow>
    </VCardText>
  </SDialog>
</template>

<script lang="ts" setup>
interface Props {
  showDialog: boolean
}

defineProps<Props>()

const emits = defineEmits<{
  (e: 'update:showDialog', show: boolean): void
  (e: 'exit' | 'cancel'): void
}>()
</script>
